'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extend = extend;
exports.getCurrentEnvironment = getCurrentEnvironment;
exports.getBrowserInfo = getBrowserInfo;
exports.setValueOrEmptyString = setValueOrEmptyString;
exports.queryStringToObject = queryStringToObject;
exports.generateGUID = generateGUID;
exports.encodeBase64 = encodeBase64;

var _base = require('base-64');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extend(obj, src) {
    for (var key in src) {
        if (src.hasOwnProperty(key) && !obj.hasOwnProperty(key)) obj[key] = src[key];
    }
    return obj;
}

var envMap = [['//identity.justgiving.com/', 'PROD'], ['.dev.', 'DEV'], ['.local.', 'DEV'], ['v3-integration', 'STAGING'], ['v3-rc.staging', 'STAGING'], ['.staging.', 'STAGING'], ['v3-sandbox.', 'SANDBOX'], ['.sandbox.', 'SANDBOX']];

function getCurrentEnvironment(url) {
    var env = 'PROD';
    if (!url) {
        return env;
    };
    var subString = url.slice(0, url.search('justgiving.com'));

    for (var i = 0; i < envMap.length; i++) {
        if (subString.indexOf(envMap[i][0]) > -1) {
            env = envMap[i][1];
            break;
        }
    }
    return env;
}

function getBrowserInfo(request) {
    if (request) {
        return {
            url: request.url,
            user_agent: request.user_agent,
            referer: request.referer,
            cookies: request.cookies
        };
    }

    return {
        url: window.location.href || null,
        user_agent: navigator.userAgent || null,
        referer: document.referrer || location.referrer || 'Direct',
        cookies: document.cookie
    };
}

function setValueOrEmptyString(propertyName, value, object) {
    if (value != null && value.length !== 0 && propertyName) {
        object[propertyName] = value;
    }
}

// Read a page's GET URL variables and return them as an associative array.
function queryStringToObject(url) {
    if (!url) return {};
    var queryStringValues = {},
        hash = void 0;
    var hashes = url.slice(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        queryStringValues[hash[0].toLowerCase()] = hash[1];
    }

    return queryStringValues;
}

function generateGUID() {
    var lut = [];for (var i = 0; i < 256; i++) {
        lut[i] = (i < 16 ? '0' : '') + i.toString(16);
    }

    var d0 = Math.random() * 0xffffffff | 0;
    var d1 = Math.random() * 0xffffffff | 0;
    var d2 = Math.random() * 0xffffffff | 0;
    var d3 = Math.random() * 0xffffffff | 0;
    return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' + lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' + lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] + lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
}

function encodeBase64(dataString) {
    return _base2.default.encode(dataString);
}


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/lib/utils.js